import { useScriptStore } from '@/shared/store/script.store.ts'
import type { Script } from '@/features/script/domain/models/script.ts'
import { useAppStore } from '@/shared/store/app.store.ts'
import { createSession } from '@/features/session/domain/use-cases/create-session.ts'
import { useHistoryStore } from '@/shared/store/history.store.tsx'
import type { Result } from '@siroc/types'

export const createScript = (
  text: string,
  storeTheScript = true
): Result<Script> => {
  const { storeScript } = useScriptStore.getState()

  const newScript: Script = {
    id: crypto.randomUUID(),
    text,
    lastUpdate: new Date(),
  }

  if (storeTheScript) {
    storeScript(newScript)
    const { session } = useAppStore.getState()

    // Create session if it doesn't exist, but don't save yet
    // Mark state as dirty since speech hasn't been created yet
    if (!session) {
      void createSession(undefined, undefined, { scripts: [newScript] })
    }

    // Mark state as dirty - speech hasn't been created yet, so we shouldn't save
    // Auto-save will trigger when speech is actually created
    useHistoryStore.setState({ saveStatus: 'dirty' })
  }

  return { ok: true, data: newScript }
}
